<template>
  <div class="multilingual-resources">
    <div
      class="anchor-page-resource-card-container"
      v-if="showResourceTile">
      <ResourceTile
        aria-live="polite"
        v-for="resource in resources"
        :key="resource.uuid"
        v-bind="resource"/>
    </div>
    <template v-else>
      <ResourcePreviewCard
        aria-live="polite"
        v-for="resource in resources"
        :key="resource.uuid"
        v-bind="resource"
        :evt-data="evtData"/>
    </template>
  </div>
</template>

<script>
import ResourcePreviewCard from '@/components/ResourcePreviewCard'
import ResourceTile from './goals/ResourceTile'
import { mapGetters } from 'vuex'

export default {
  name: 'MultilingualResourcePreviewCards',
  components: {
    ResourcePreviewCard,
    ResourceTile
  },
  props: {
    resources: {
      type: Array,
      required: true
    },
    showResourceTile: {
      type: Boolean,
      default: false
    },
    evtData: {
      type: Object,
      default: () => {}
    },
    objectId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('goaldetail', [
      'selectedLanguageById'
    ]),
    selectedLanguage() {
      return this.selectedLanguageById(this.objectId)
    }
  },
  eventContext() {
    return {
      selected_language: this.selectedLanguage,
      ...this.evtData
    }
  }
}
</script>

<style scoped lang="less">
.anchor-page-resource-card-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
